import React, { useContext, useEffect, useRef, useState } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { LoginCallback, SecureRoute, Security, useOktaAuth } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import '@okta/okta-signin-widget/css/okta-sign-in.min.css';
import OktaSignIn from '@okta/okta-signin-widget';
import { AuthContext } from './context';
const OktaSignInWidget = () => {
  var _login$className;
  const {
    onLogin,
    login,
    scopes,
    issuer,
    clientId,
    baseURL,
    oktaBaseURL,
    title = 'Log in to UPshow'
  } = useContext(AuthContext);
  const {
    oktaAuth
  } = useOktaAuth();
  const widgetRef = useRef();
  useEffect(() => {
    if (!widgetRef.current) return;
    const widget = new OktaSignIn({
      baseUrl: oktaBaseURL,
      clientId,
      redirectUri: baseURL + '/callback',
      authParams: {
        issuer,
        scopes
      },
      useInteractionCodeFlow: false,
      useClassicEngine: true,
      logo: login.logo,
      language: 'en',
      i18n: {
        en: {
          'primaryauth.title': title,
          'primaryauth.username.placeholder': 'Your UPshow Username',
          'primaryauth.submit': 'Log In'
        }
      }
    });
    widget.showSignInToGetTokens({
      el: widgetRef.current
    }).then(tokens => {
      if (onLogin) onLogin(tokens.accessToken, oktaAuth);
      oktaAuth.handleLoginRedirect(tokens);
    });
    return () => widget.remove();
  }, [oktaAuth, widgetRef]);
  return /*#__PURE__*/React.createElement("div", {
    className: (_login$className = login.className) !== null && _login$className !== void 0 ? _login$className : ''
  }, /*#__PURE__*/React.createElement("div", {
    ref: widgetRef
  }));
};
const Login = () => {
  const {
    authState
  } = useOktaAuth();
  if (!authState) return null;
  return authState.isAuthenticated ? /*#__PURE__*/React.createElement(Redirect, {
    to: {
      pathname: '/'
    }
  }) : /*#__PURE__*/React.createElement(OktaSignInWidget, null);
};
export default function UPShowSecurity(props) {
  var _history$location;
  const {
    issuer,
    clientId,
    baseURL,
    children,
    scopes
  } = props;
  const history = useHistory();
  const redirectUri = baseURL + '/callback';
  const postLogoutRedirectUri = baseURL + '/logged_out';
  const [oktaAuth] = useState(new OktaAuth({
    issuer,
    clientId,
    redirectUri,
    postLogoutRedirectUri,
    scopes,
    devMode: false,
    tokenManager: {
      autoRenew: true,
      expireEarlySeconds: 240
    }
  }));
  window.oktaAuth = oktaAuth;
  const onAuthRequired = () => history.push('/login');
  const restoreOriginalUri = async (_oktaAuth, originalUri) => history.replace(toRelativeUrl(originalUri || '/', baseURL));
  if (((_history$location = history.location) === null || _history$location === void 0 ? void 0 : _history$location.pathname) === '/force-logout') {
    oktaAuth.signOut();
  }
  return /*#__PURE__*/React.createElement(Security, {
    oktaAuth: oktaAuth,
    onAuthRequired: onAuthRequired,
    restoreOriginalUri: restoreOriginalUri
  }, /*#__PURE__*/React.createElement(AuthContext.Provider, {
    value: {
      oktaAuth,
      ...props
    }
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/callback",
    component: LoginCallback
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/logged_out",
    render: () => /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    })
  }), /*#__PURE__*/React.createElement(SecureRoute, {
    path: "/"
  }, children))));
}